import dayjs from 'dayjs'
var localizedFormat = require('dayjs/plugin/localizedFormat')
var utc = require('dayjs/plugin/utc')
require('dayjs/locale/pt')

dayjs.extend(localizedFormat)
dayjs.extend(utc)
dayjs.locale('pt')

const formats = {
  date: 'L',
  dateAndHour: 'L - LTS'
}

export function formatCurrency (text, currency) {
  if (!text) return text
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: currency }).format(text)
}

export function formatCEP (text) {
  if (!text) return text
  if (text.length === 8) return `${text.slice(0, 5)}-${text.slice(5, 8)}`
  return text
}

export function formatDocument (text) {
  if (!text) return text
  if (typeof text !== 'string') return text
  const clean = text.replace(/[^A-Z0-9]/gi, '').toUpperCase()
  if (clean.length === 11) return `${clean.slice(0, 3)}.${clean.slice(3, 6)}.${clean.slice(6, 9)}-${clean.slice(9, 11)}`
  if (clean.length === 14) return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5, 8)}/${clean.slice(8, 12)}-${clean.slice(12, 14)}`
  return text
}

export function formatPhone (text) {
  if (!text) return text
  if (text.length === 11) return `(${text.slice(0, 2)}) ${text.slice(2, 7)}-${text.slice(7, 11)}`
  if (text.length === 10) return `(${text.slice(0, 2)}) ${text.slice(2, 6)}-${text.slice(6, 10)}`
  return text
}

export function formatDate (date, format) {
  if (date) return dayjs.utc(date).local().format(formats[format])
  return '-'
}
